import { ChartRangeType } from "./enums";

export * from "./enums";

export const CHART_BAR_TABS = [
  { label: "Week", value: ChartRangeType.Week },
  { label: "Month", value: ChartRangeType.Month },
  { label: "Year", value: ChartRangeType.Year },
  { label: "Custom", value: ChartRangeType.Custom }
];

export const STATISTIC_BARS_WIDTH: Record<string, number> = {
  week: 95,
  month: 18,
  year: 54
};

export const STATISTIC_BARS_DATA: Record<string, number> = {
  week: 7,
  month: 31,
  year: 12
};

export const CHART_DATE_FORMATS_FOR_PICKER: Record<ChartRangeType, string> = {
  week: "MMM dd, yyyy",
  month: "MMMM yyyy",
  year: "yyyy",
  custom: "MMM dd, yyyy"
};

export const CHART_BODY_FONT = {
  family: "'Eudoxus Sans', sans-serif",
  weight: 700,
  size: 13,
  lineHeight: "18px"
};

export const CHART_TITLE_FONT = {
  family: "'Eudoxus Sans', sans-serif",
  weight: 400,
  size: 12,
  lineHeight: "16px"
};

export const CHART_Y_TICKS_CONFIG = {
  display: true,
  color: "#7E7E8B",
  font: { family: "'Inter', sans-serif", size: 13, lineHeight: "18px" },
  callback: (value: number | string) => Math.ceil(+value)
};

export const CHART_X_TICKS_CONFIG = {
  color: "#7E7E8B",
  font: {
    family: "'Inter', sans-serif",
    size: 13,
    lineHeight: "18px"
  },
  maxRotation: 0,
  minRotation: 0
};
